import { render, staticRenderFns } from "./TwoPanelMultiselect.vue?vue&type=template&id=1e6a8232"
import script from "./TwoPanelMultiselect.vue?vue&type=script&lang=js"
export * from "./TwoPanelMultiselect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports